/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class DynamicMenuServiceConstants {
}
DynamicMenuServiceConstants.GLOBAL_KEY = 'window.sirius.shared.dynamicMenu';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHluYW1pYy1tZW51LXNlcnZpY2UuY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NoYXJlZC9keW5hbWljLW1lbnUvZHluYW1pYy1tZW51LXNlcnZpY2UuY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLDJCQUEyQjs7QUFDYixzQ0FBVSxHQUFHLGtDQUFrQyxDQUFDIn0=